import { get, post, patch } from 'api/request';
import urls from 'configs/urls';

export const getCampaignsList = ({ data }) =>
  get(null, false, urls.campaignsUrls.getCampaignsList, data);

export const getCampaignInfo = ({ campaignKey }) =>
  get(null, false, `${urls.campaignsUrls.getCampaignsList}/${campaignKey}`, null);

export const addCampaign = ({ data }) => post(null, false, urls.campaignsUrls.addCampaign, data);

export const editCampaign = ({ campaignKey, data }) =>
  patch(null, false, `${urls.campaignsUrls.editCampaign}/${campaignKey}`, data);
